import React from 'react';

/**
 * Full-page notice shown instead of the app while the backend is suspended.
 * Rendered from index.tsx when REACT_APP_MAINTENANCE_MODE is "true" at build
 * time. It makes no API or auth calls, so it works with the backend down.
 */
const MaintenancePage: React.FC = () => (
  <main
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      boxSizing: 'border-box',
      background: 'var(--theme-bg, #EFEDE8)',
      color: 'var(--theme-text, #1B1B1F)',
      fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    }}
  >
    <div style={{ maxWidth: 480, textAlign: 'center' }}>
      {/* Tailwind's preflight makes img block-level, so centre it with margins. */}
      <img src="/icon.svg" alt="" width={48} height={48} style={{ margin: '0 auto 24px' }} />
      <h1
        style={{
          fontFamily: "'Newsreader', Georgia, serif",
          fontWeight: 500,
          fontSize: 36,
          lineHeight: 1.2,
          margin: '0 0 16px',
        }}
      >
        Glyphe is being rebuilt
      </h1>
      <p
        style={{
          fontSize: 16,
          lineHeight: 1.6,
          margin: 0,
          color: 'var(--theme-text-muted, #6E6A5F)',
        }}
      >
        We have taken the app offline while we work on the next version. Thank
        you for your patience. We will be back soon.
      </p>
    </div>
  </main>
);

export default MaintenancePage;
